import { queryOptions } from "@tanstack/react-query";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { fetchOccResourcePageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { CheckoutSummaryPageInitialData } from "./checkoutSummaryPageInitialData";

export const checkoutSummaryPageQueryOptions = (activeCartId?: string) =>
  queryOptions({
    queryKey: pageDataKeys.checkoutSummary(activeCartId),
    queryFn: () =>
      fetchOccResourcePageData<PageInitialDataResult<CheckoutSummaryPageInitialData>>(
        `${occCartUserPath()}/carts/${encodeURIComponent(requireActiveCartId(activeCartId))}/page-data/checkout`,
      ),
    enabled: Boolean(activeCartId),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });

function requireActiveCartId(activeCartId: string | undefined): string {
  if (!activeCartId) {
    throw new Error("Cannot load Checkout page data without an Active Cart ID");
  }
  return activeCartId;
}
